package dev.lingvo.shared.screenshots.templates

import dev.lingvo.shared.screenshots.doc.FrameFinish
import dev.lingvo.shared.screenshots.doc.SceneKind
import dev.lingvo.shared.screenshots.doc.SceneSpec

/** One hue family supplies depth through three soft lights; SILVER bleeds below the canvas. Play stays frameless. */
object Aurora : Template by StyledTemplate("aurora", "Aurora", TemplateCategory.DARK, "Inter Tight", 700, .090, .042, 1.08, -.02, FrameFinish.SILVER)

/** Warm grain and a left-aligned serif read as print craft; one soft shadow grounds GRAPHITE. Play stays frameless. */
object Paper : Template by StyledTemplate("paper", "Paper", TemplateCategory.MINIMAL, "Fraunces", 600, .085, .042, 1.05, -.01, FrameFinish.GRAPHITE)

/** Grayscale and one accent on the numbered eyebrow make restraint visible. Play stays frameless. */
object Mono : Template by StyledTemplate("mono", "Mono", TemplateCategory.MINIMAL, "Inter", 600, .090, .042, 1.10, 0.0, FrameFinish.GRAPHITE)

/** Fixed lightness and rotating related hues make a coherent loud set; the pair proves breadth. Play stays frameless. */
object Pop : Template by StyledTemplate("pop", "Pop", TemplateCategory.PLAYFUL, "Bricolage Grotesque", 800, .100, .045, 1.0, -.03, FrameFinish.WHITE, SceneSpec(SceneKind.TILTED_PAIR))
